import { isArray } from "lodash-es"
import dayjs from "dayjs"
import { useHost } from "../global/host.global"
import { useCurrentDepartment } from "./useAuth"

function generateHash(parameters) {
  let linkString = ""
  try {
    const params = Object.keys(parameters)
    // Map Array Into Values
    params.forEach((key, idx) => {
      let param = parameters[key]
      if (isArray(param)) param = param.join(",")
      if (param) {
        linkString = linkString
          .concat(`${key}=${param}`)
          .concat(idx === params.length - 1 ? "" : "&")
      }
    })
    // encodes the params to not directly expose the sensitive information
    const linkHash = btoa(linkString)
    return linkHash
  } catch (err) {
    return ""
  }
}
/**
 *
 * @param {date} param0 The current date to send in the querySting formatted automatically as DDMMYYYY
 */
const useRedirect = ({ date, ...otherParams }: any) => {
  const id = useCurrentDepartment()
  const { subdomain } = useHost()
  const parameters = {
    dep: id,
    tenant: subdomain,
    date: date ? dayjs(date).format("DDMMYYYY") : null,
    ...otherParams,
  }

  const redirect = (link, params?: any, self?: boolean) => {
    let encodedString = generateHash({
      ...parameters,
      ...params,
    })

    if (self) {
      window.open(`${link}${encodedString}`, "_parent")
    } else {
      window.open(`${link}${encodedString}`, "__blank")
    }
  }
  return [redirect]
}

export default useRedirect
